import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "text" }, "成人", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text" }, "儿童", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text" }, "婴儿", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_form_item = _resolveComponent("el-form-item")

  return (_openBlock(), _createBlock(_component_el_form_item, {
    label: "乘机人数",
    prop: _ctx.prop
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_popover, {
        placement: "bottom",
        width: 400,
        trigger: "click"
      }, {
        reference: _withCtx(() => [
          _createVNode(_component_el_input, {
            style: {"width":"207px"},
            modelValue: _ctx.passengerInfo,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.passengerInfo = $event)),
            placeholder: "请选择乘机人员",
            readonly: ""
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_input_number, {
            modelValue: _ctx.num[0],
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.num[0] = $event)),
            min: 1,
            max: 3,
            size: "small",
            label: "成人"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_input_number, {
            modelValue: _ctx.num[1],
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.num[1] = $event)),
            min: 0,
            max: 3,
            size: "small",
            label: "儿童"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_input_number, {
            modelValue: _ctx.num[2],
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.num[2] = $event)),
            min: 0,
            max: 3,
            size: "small",
            label: "婴儿"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["prop"]))
}